import { HttpClient, HttpErrorResponse, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { catchError, Observable, throwError } from "rxjs";
import { AlertMessage, EventMessageBusService } from "./event-message-bus.service";
import { environment } from "../../../environments/environment";

const baseUrl = environment.publicEndpoint;

@Injectable({
  providedIn: 'root',
})

export class ApplicationHttpService {
    constructor(private http: HttpClient, private messageService: EventMessageBusService) {
    }

    private handleError(url: string, error: any): Observable<never> {
        console.error(`${url} failed`, error);

        if (error instanceof HttpErrorResponse) {
            let errorPayload: any = {};

            if (error.error) {
                if (typeof error.error === 'string') {
                    errorPayload = { message: error.error };
                } else if (typeof error.error === 'object') {
                    errorPayload = error.error;
                }
            } else {
                errorPayload = { message: error.message };
            }

            this.sendErrorMessage(errorPayload.message ?? `Request failed (HTTP ${error.status})`);
            return throwError(() => errorPayload);
        }

        this.sendErrorMessage(error?.message || 'Unknown error');
        return throwError(() => ({ message: error?.message || 'Unknown error' }));
    }

    private sendErrorMessage(text: string) {
        let message = {
            text: text,
            type: 'error',
            alertOptions: {
                timeout: 5000,
                closable: true
            }
        } as AlertMessage;
        this.messageService.postMessage(message);
    }
 
 

    public get<T>(url: string, params?: any, options?: { headers?: HttpHeaders, params?: any }): Observable<T> {

        if (params) {
            params = `?${params}`;
        }
        else if (params === undefined || params === null) {
            params = '';
        }
        return this.http.get<T>(`${baseUrl}/${url}${params}`, { headers: options?.headers }).pipe(
            catchError((error: any) => {
                return this.handleError(url, error);
            })
        );
    }

    public post<T>(url: string, body: any, options?: { headers?: HttpHeaders, params?: any }): Observable<T> {
        let queryParams = options?.params ? `?${options.params}` : '';
        let _url = `${baseUrl}/${url}${queryParams}`;
        
        
        return this.http.post<T>(_url, body, { headers: options?.headers }).pipe(
            catchError((error: any) => {
                return this.handleError(url, error);
            })
        );
    }

    public put<T>(url: string, body: any, params?: any): Observable<T> {
        let _url = params ? `${baseUrl}/${url}?${params}` : `${baseUrl}/${url}`;
        return this.http.put<T>(_url, body).pipe(
            catchError((error: any) => {
                return this.handleError(url, error);
            })
        );
    }

    public patch<T>(url: string, body: any): Observable<T> {
        return this.http.patch<T>(`${baseUrl}/${url}`, body).pipe(
            catchError((error: any) => {
                return this.handleError(url, error);
            })
        );
    }

    public delete<T>(url: string): Observable<T> {
        return this.http.delete<T>(`${baseUrl}/${url}`).pipe(
            catchError((error: any) => {
                return this.handleError(url, error);
            })
        );
    }

    public getFile(url: string): Observable<Blob> {
        return this.http.get(`${baseUrl}/${url}`, {responseType: 'blob'}).pipe(
            catchError((error: any) => {
                return this.handleError(url, error);
            })
        );
    }

    public postForBlob(url: string, body: any): Observable<Blob> {
        return this.http.post(`${baseUrl}/${url}`, body, {responseType: 'blob'}).pipe(
            catchError((error: any) => {
                return this.handleError(url, error);
            })
        );
    }

    public sendFile(url: string, base64: string): Observable<any> {
        const headers = new HttpHeaders({
            'Content-Type': 'text/plain' // Или application/json, если нужно
          });
        return this.http.post(`${baseUrl}/${url}`, base64, {headers}).pipe(
            catchError((error: any) => {
                return this.handleError(url, error);
            })
        )
    }

    public uploadFile(url: string, formData: FormData): Observable<any> {
        return this.http.post(`${baseUrl}/${url}`, formData).pipe(
            catchError((error: any) => {
                return this.handleError(url, error);
            })
        );
    }

    // public async download(fileUrl: string, meta: AttachMeta) {
    //     const response = await this.http.get(fileUrl, { responseType: 'blob' }).toPromise();
    //     if (response) {
    //         const blob = new Blob([response], { type: meta.contentType });
    //         const url = window.URL.createObjectURL(blob);
    
    //         const link = document.createElement('a');
    //         link.href = url;
    //         link.download = meta.fileName;
    //         link.click();
    
    //         window.URL.revokeObjectURL(url);
    //     }
    // }

    public async downloadApplicationPdf(fileUrl: string) {
        const response = await this.http.get(fileUrl, { responseType: 'blob' }).toPromise();
        if (response) {
            const blob = new Blob([response], { type: 'application/pdf' });
            const url = window.URL.createObjectURL(blob);
    
            const link = document.createElement('a');
            link.href = url;
            link.download = "Application.pdf";
            link.click();
    
            window.URL.revokeObjectURL(url);
        }
    }

}